import { render, staticRenderFns } from "./ButtonOpenFbConversation.vue?vue&type=template&id=c049ae7e&"
import script from "./ButtonOpenFbConversation.vue?vue&type=script&lang=js&"
export * from "./ButtonOpenFbConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports